import { Feeds } from "./pages/Feeds.js";
import { Dados } from "./pages/Dados.js";
import type { ReactNode } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./lib/auth.js";
import { Layout } from "./components/Layout.js";
import { Login } from "./pages/Login.js";
import { Dashboard } from "./pages/Dashboard.js";
import { Inicio } from "./pages/Inicio.js";
import { Torre } from "./pages/Torre.js";
import { Planilha } from "./pages/Planilha.js";
import { Painel } from "./pages/Painel.js";
import { Vincular } from "./pages/Vincular.js";
import { TrocarSenha } from "./pages/TrocarSenha.js";
import { Operacoes } from "./pages/Operacoes.js";
import { Programacao } from "./pages/Programacao.js";
import { Cadastros } from "./pages/Cadastros.js";
import { Metas } from "./pages/Metas.js";
import { Insights } from "./pages/Insights.js";
import { Inconsistencias } from "./pages/Inconsistencias.js";
import { Agente } from "./pages/Agente.js";
import { ExplorarIA } from "./pages/ExplorarIA.js";
import { Admin } from "./pages/Admin.js";
import { Chamados } from "./pages/Chamados.js";
import { Entrega } from "./pages/Entrega.js";
import { Atualizacoes } from "./pages/Atualizacoes.js";
import { Convite } from "./pages/Convite.js";
import { SemAcesso } from "./components/SemAcesso.js";

function Protected({ children, area }: { children: ReactNode; area?: string }) {
  const { user, precisaTrocarSenha, canArea } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  // A exigência do primeiro acesso vive AQUI, no portão por onde toda página
  // protegida passa — não em cada tela. Esconder só o link da barra lateral
  // deixaria o portal inteiro acessível pela URL.
  if (precisaTrocarSenha) return <Navigate to="/trocar-senha" replace />;
  // Mesma lógica para as permissões (D-27): a URL digitada não fura o grupo.
  if (area && !canArea(area)) return <Layout><SemAcesso /></Layout>;
  return <Layout>{children}</Layout>;
}

// A troca de senha é a única página protegida FORA do portão acima: quem está
// preso pela exigência precisa conseguir chegar nela.
function ProtectedSemBloqueio({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><Inicio /></Protected>} />
      <Route path="/convite/:token" element={<Convite />} />
      <Route path="/indicadores" element={<Protected area="dashboard"><Dashboard /></Protected>} />
      <Route path="/trocar-senha" element={<ProtectedSemBloqueio><TrocarSenha /></ProtectedSemBloqueio>} />
      <Route path="/vincular" element={<Protected area="vinculo"><Vincular /></Protected>} />
      <Route path="/torre" element={<Protected area="paineis"><Torre /></Protected>} />
      <Route path="/painel" element={<Protected area="paineis"><Painel /></Protected>} />
      <Route path="/torre/planilha" element={<Protected area="paineis"><Planilha /></Protected>} />
      <Route path="/operacoes" element={<Protected area="operacoes"><Operacoes /></Protected>} />
      <Route path="/feeds" element={<Protected area="feeds"><Feeds /></Protected>} />
      <Route path="/dados" element={<Protected area="dados"><Dados /></Protected>} />
      <Route path="/programacao" element={<Protected area="programacao"><Programacao /></Protected>} />
      <Route path="/cadastros" element={<Protected area="cadastros"><Cadastros /></Protected>} />
      <Route path="/cadastros/:entity" element={<Protected area="cadastros"><Cadastros /></Protected>} />
      <Route path="/metas" element={<Protected area="metas"><Metas /></Protected>} />
      <Route path="/insights" element={<Protected area="insights"><Insights /></Protected>} />
      <Route path="/explorar" element={<Protected area="explorar"><ExplorarIA /></Protected>} />
      <Route path="/inconsistencias" element={<Protected area="inconsistencias"><Inconsistencias /></Protected>} />
      <Route path="/agente" element={<Protected area="agente"><Agente /></Protected>} />
      <Route path="/atualizacoes" element={<Protected><Atualizacoes /></Protected>} />
      {/* Aberto a todos: a API é que estreita a fila para quem não tria.
          Quem relatou um erro precisa poder ver o que aconteceu com ele. */}
      <Route path="/chamados" element={<Protected><Chamados /></Protected>} />
      <Route path="/entrega" element={<Protected area="entrega"><Entrega /></Protected>} />
      <Route path="/admin" element={<Protected area="admin"><Admin /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
